/** @flow */
import { startRequest, finishRequest } from "@store/utils";
import * as actions from "@modules/reporting/constants/actions";
import initialState from "./state";
import type { DataForecastsState } from "./types";
import { cloneObject } from "@utils/object";

export const startLoading = (state: DataForecastsState) => ({ payload }: Object) =>
  startRequest(state);

export const finishLoading = (state: DataForecastsState) => ({ payload }: Object) =>
  finishRequest(state);

export const onGetDataForecastsSuccess = (state: DataForecastsState) => ({ payload }: Object) => {
  return {
    ...finishRequest(state),
    data: {
      ...payload,
    },
  };
};

export default (state: DataForecastsState = initialState, action: Object): DataForecastsState => {
  const act = {
    [actions.GetDataForecasts]: startLoading,
    [actions.GetDataForecastsSuccess]: onGetDataForecastsSuccess,
    [actions.GetDataForecastsError]: finishLoading,
  };

  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
